$(document).ready(function() {
	//var headerHeight = $('hf-sub-nav').outerHeight();
	var scrolledPoint = 88 + 40;

	// on load, ensure correct position of fixed callout
	if ($(this).scrollTop() > scrolledPoint) {
		$('.hf-sub-nav').addClass('fixed-nav');
	} else {
		$('.hf-sub-nav').removeClass('fixed-nav');
	}
	// on scroll, change position of header fixed callout
	$(window).scroll(function() {
		if ($(this).scrollTop() > scrolledPoint) {
			$('.hf-sub-nav').addClass('fixed-nav');
		} else {
			$('.hf-sub-nav').removeClass('fixed-nav');
		}
	});
});
